class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);


(() => {
  if (window.MarameKeywordSearch) return;
  const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ');
  const decode = (value) => {
    const query = normalize(value);
    return query.startsWith('((') && query.endsWith('))')
      ? query.slice(2, -2).split(' AND ').map((word) => word.replaceAll('"', '')).join(' ')
      : query;
  };
  const colours = () => {
    try {
      const config = JSON.parse(document.querySelector('[data-marame-search-colours]')?.dataset.marameSearchColours || '{}');
      if (!['filter.v.t.shopify.color-pattern', 'filter.v.option.color', 'filter.v.option.colour'].includes(config.param)) return { values: [] };
      return { param: config.param, values: (Array.isArray(config.values) ? config.values : []).slice(0, 100) };
    } catch (_) {
      return { values: [] };
    }
  };
  const keywordTerms = new Set(['crew', 'v-neck', 'jumpers']);
  const compile = (value, config = colours()) => {
    const query = normalize(value);
    const words = query.split(' ');
    const advanced = /[:*"\\()[\]{}<>|]|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)|(?:^|\s)[+-]/.test(query);
    const code = !query.includes(' ') && /\d/.test(query);
    if (!query || advanced || code || words.length > 20) return { query, filters: [] };
    const lower = words.map((word) => word.toLowerCase());
    const selected = new Set();
    const covered = new Set();
    const values = (config.values || []).map((item) => ({ ...item, words: normalize(item.label).toLowerCase().split(' ') }))
      .filter((item) => item.words[0] && typeof item.value === 'string')
      .sort((a, b) => b.words.length - a.words.length);
    for (const item of values) {
      for (let start = 0; start <= lower.length - item.words.length; start += 1) {
        if (item.words.every((word, offset) => lower[start + offset] === word && !covered.has(start + offset))) {
          item.words.forEach((_, offset) => covered.add(start + offset));
          selected.add(item.value);
        }
      }
    }
    const garmentWords = lower.filter((_, index) => !covered.has(index));
    const singleGarment = words.length === 1 && keywordTerms.has(lower[0]);
    const crewNeck = lower.join(' ') === 'crew neck';
    const colouredGarment = selected.size === 1 && covered.size === 1 && garmentWords.length === 1 && keywordTerms.has(garmentWords[0]);
    if (!singleGarment && !crewNeck && !colouredGarment) return { query, filters: [] };
    return {
      query: `((${words.map((word, index) => covered.has(index) ? word : `"${word}"`).join(' AND ')}))`,
      filters: config.param ? Array.from(selected, (value) => [config.param, value]) : [],
    };
  };
  const enhanceLinks = (scope = document) => {
    scope.querySelectorAll('a[data-marame-search-query]').forEach((link) => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const result = compile(link.dataset.marameSearchQuery);
      url.searchParams.set('q', result.query);
      result.filters.forEach(([name, value]) => url.searchParams.append(name, value));
      link.href = url.href;
      link.removeAttribute('data-marame-search-query');
    });
  };
  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[role="search"]')) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || input.disabled) return;
    const target = new URL(form.action, location.href);
    if (target.origin !== location.origin || !/\/search\/?$/.test(target.pathname) || form.method.toLowerCase() !== 'get') return;
    const result = compile(input.value);
    event.formData.set('q', result.query);
    result.filters.forEach(([name, value]) => event.formData.append(name, value));
  }, { capture: true });
  window.MarameKeywordSearch = { compile, decode, enhanceLinks };
})();
